import React, { useEffect, useState, useRef } from "react";
import Swal2 from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import "../styles/payments.css";
import Loading from "../helpers/loading_component.js";
import emailjs from "@emailjs/browser";
import LoadingPopup from "../helpers/loading_component.js";
import SelectSearch from "react-select-search";
import { secretKey } from "../.././data";

const MySwal = withReactContent(Swal2);

const EditWPS = (props) => {
  const [value, setValue] = useState(props.client.wps);
  const [loading, setLoading] = useState(false);

  const editClient = async (e) => {
    if (validatePayment()) {
      setLoading(true);

      var body = {
        id: props.client.id,
        wps: value,
      };

      await fetch("https://apidevkppp.ftpeople.pl/addWPSClient", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: secretKey,
        },
        body: JSON.stringify(body),
      })
        .then((response) => response.json())
        .then((data) => {})
        .catch((error) => {});
      props.logClientAction("Edytowano WPS", props.client.id);

      MySwal.fire({
        icon: "success",
        title: "Edytowano",
        text: "sprawę",
      }).then(async (result) => {
        props.close();
      });
    } else {
      MySwal.fire({
        icon: "error",
        title: "Błąd",
        text: "Wypełnij wymagane pola formularza",
      });
    }
  };

  const validatePayment = (e) => {
    if (value.length > 0) {
      return true;
    } else {
      return false;
    }
  };

  return (
    <div className="mainContainerAddClient">
      {loading ? (
        <LoadingPopup />
      ) : (
        <>
          <div className="closeButtonAP">
            <button className="closeClientButton" onClick={props.close}>
              X
            </button>
          </div>

          <div className="sepAddC">Informacje o sprawie</div>

          <div className="inputBox">
            <div className="inputCol_3">
              <label>
                WPS <span className="requiredStar">*</span>
              </label>
              <input
                type="number"
                id="name"
                name="name"
                value={value}
                onChange={(e) => setValue(e.target.value)}
              />
            </div>
          </div>

          <div className="saveBoxAP">
            <button className="paymentMenuButton" onClick={editClient}>
              zapisz
            </button>
          </div>
        </>
      )}
    </div>
  );
};

export default EditWPS;
